// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FinancialScreeningPrescriberAddress } from './financialScreeningPrescriberAddress.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class FinancialScreeningPrescriberRequest {
    'address'?: FinancialScreeningPrescriberAddress | null;
    'fax'?: string;
    'firstName'?: string;
    'lastName'?: string;
    'npi'?: string;
    'phone'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof FinancialScreeningPrescriberRequest>> = [
        {
            "name":     "address",
            "baseName": "address",
            "type":     "FinancialScreeningPrescriberAddress"
        },
        {
            "name":     "fax",
            "baseName": "fax",
            "type":     "string"
        },
        {
            "name":     "firstName",
            "baseName": "firstName",
            "type":     "string"
        },
        {
            "name":     "lastName",
            "baseName": "lastName",
            "type":     "string"
        },
        {
            "name":     "npi",
            "baseName": "npi",
            "type":     "string"
        },
        {
            "name":     "phone",
            "baseName": "phone",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return FinancialScreeningPrescriberRequest.attributeTypeMap;
    }
}
